/**
 * Given a field with nested keys, generate a string accessor
 * @param {{parentKeys: String[], key: String}} field Field to use
 * @return {String} String accessor
 */
export default field => [...(field.parentKeys || []), field.key].join('.');